import { render } from "./UomSelector.vue?vue&type=template&id=44adb9a0&scoped=true"
import script from "./UomSelector.vue?vue&type=script&lang=js"
export * from "./UomSelector.vue?vue&type=script&lang=js"

import "./UomSelector.vue?vue&type=style&index=0&id=44adb9a0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44adb9a0"]])

export default __exports__